import { http } from '@/utils/axios'

// 合作院校、合作机构列表
export function getListByCategory(data) {
    return http({
        url: http.baseUrl('elSchool/getListByCategory'),
        method: 'get',
        params: http.params(data)
    })
}

// 根据合作院校、合作机构获取任课老师信息
export function getTeacherBySchool(data) {
    return http({
        url: http.baseUrl('elUser/getTeacherBySchool'),
        method: 'get',
        params: http.params(data)
    })
}

// 获取直播课时列表
export function getbatchList(data) {
    return http({
        url: http.baseUrl(`liveCourse/batchList?courseId=${data.courseId}`),
        method: 'post',
        data: http.params(data)
    })
}

// 查看直播课时信息
export function getBatchById(data) {
    return http({
        url: http.baseUrl('liveCourse/getBatchById'),
        method: 'get',
        params: http.params(data)
    })
}

// 直播课时学员列表
export function getStudentList(data) {
    return http({
        url: http.baseUrl('liveCourse/studentList'),
        method: 'get',
        params: http.params(data)
    })
}

// 导出直播课时学员列表
export function exportStudentList(data) {
    return http({
        url: http.baseUrl('liveCourse/exportStudentList'),
        method: 'get',
        params: http.params(data)
    })
}

// 直播课时考勤列表
export function getSignList(data) {
    return http({
        url: http.baseUrl('liveCourse/signList'),
        method: 'post',
        data: http.params(data)
    })
}
// 导出直播课时考勤列表
export function exportSignList(data) {
    return http({
        url: http.baseUrl('liveCourse/exportSignList'),
        method: 'get',
        params: http.params(data)
    })
}

// 取消直播课时
export function cancelBatch(data) {
    return http({
        url: http.baseUrl('liveCourse/cancelBatch'),
        method: 'get',
        params: http.params(data)
    })
}

// 添加或修改直播课时
export function saveOrUpdateLiveCourse(data) {
    return http({
        url: http.baseUrl('/courseTeacherManage/saveOrUpdateLiveCourse'),
        method: 'get',
        params: http.params(data)
    })
}

// 获取直播班级列表
export function getBatchList(data) {
    return http({
        url: http.baseUrl('/courseTeacherManage/getBatchList'),
        method: 'post',
        params: http.params(data)
    })
}